import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-white dark:bg-gray-900 flex items-center justify-center px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "max-w-4xl mx-auto text-center" }
const _hoisted_3 = { class: "mb-8 flex justify-center" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "flex flex-col sm:flex-row items-center justify-center gap-4" }

import { useTitle } from '@/composables/ui/useTitle'
import { useRouter } from 'vue-router'
import { computed } from 'vue'
import NotFoundIcon from '@/components/icons/404.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NotFoundView',
  setup(__props) {

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Jeducare')

useTitle(`Page Not Found - ${appTitle.value}`)

const router = useRouter()

// Handle going back
const handleGoBack = () => {
  router.back()
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(NotFoundIcon)
        ])
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mb-12 space-y-4" }, [
        _createElementVNode("h1", { class: "text-3xl md:text-4xl font-extrabold text-[#0b6623] dark:text-emerald-400" }, " Page Not Found "),
        _createElementVNode("p", { class: "text-base md:text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto leading-relaxed" }, " The page you're looking for doesn't exist or has been moved. Please check the URL or return to the main portal. ")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "group relative inline-flex items-center justify-center px-8 py-3.5 text-base font-bold text-[#1a1a1a] bg-[#ffd62e] hover:bg-[#e6be19] rounded-full shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              "stroke-width": "2",
              stroke: "currentColor",
              class: "w-5 h-5 mr-2 transition-transform group-hover:scale-110"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
              })
            ], -1),
            _createTextVNode(" Return to Portal ", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("button", {
          onClick: handleGoBack,
          class: "group relative inline-flex items-center justify-center px-8 py-3.5 text-base font-bold text-[#0275b1] dark:text-sky-300 bg-white dark:bg-gray-800 border-2 border-[#0275b1] dark:border-sky-500 hover:bg-[#edf6fd] dark:hover:bg-gray-700 rounded-full shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200"
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            "stroke-width": "2",
            stroke: "currentColor",
            class: "w-5 h-5 mr-2 transition-transform group-hover:scale-110"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
            })
          ], -1),
          _createTextVNode(" Go Back ", -1),
          _createElementVNode("div", { class: "absolute inset-0 rounded-full bg-secondary/10 dark:bg-secondary-dark/10 opacity-0 group-hover:opacity-20 transition-opacity duration-300" }, null, -1)
        ]))])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mt-16 flex justify-center space-x-8 opacity-60" }, [
        _createElementVNode("div", { class: "w-3 h-3 bg-primary dark:bg-primary-dark rounded-full animate-bounce" }),
        _createElementVNode("div", {
          class: "w-3 h-3 bg-secondary dark:bg-secondary-dark rounded-full animate-bounce",
          style: {"animation-delay":"0.1s"}
        }),
        _createElementVNode("div", {
          class: "w-3 h-3 bg-primary dark:bg-primary-dark rounded-full animate-bounce",
          style: {"animation-delay":"0.2s"}
        })
      ], -1))
    ])
  ]))
}
}

})